import React, { useEffect, useState } from 'react'
import common from '../../../methods/common';
// import { useHistory } from "react-router-dom";
// import history from '../../../history.js';
import { useNavigate } from "react-router-dom";


const LoginForm = (props) => {
    const [loginData, setLogindata] = useState({})
    const [error, setError] = useState("");

    const navigate = useNavigate();

    useEffect(()=>{
        let employee = common.getEmployeeFromLocal();
        if(employee.full_name && !employee.is_employee_gone){
            navigate("/home")
        }
    },[navigate])


    const handleChange = (e) => {
        setError("")
        let name = e.target.name;
        let value = e.target.value;
        setLogindata(prev => ({ ...prev, [name]: value }))
    }

    const handleSubmit = () => {

        if (common.checkCredentials(loginData)) {
            navigate("/home");

        } else {
            setError("Wrong username or password")
        }
    }

    return (
        <div 
        className='client-form-main-wrap'
        style={{
            backgroundImage: "url(" + require("../../../assets/img/vacspl/plant.jpeg") + ")",
        }}
        >
            <div className='client-form-main'
               
            >
                <div className='client-form formSubmit'>
                    <div className='heading-loginform'>
                        Please Enter Login Details
                    </div>
                    <div className="labelinput">
                        {/* <label>Company Name</label> */}
                        <input type="text" placeholder='User Name' name="userName" onChange={handleChange} />
                    </div>
                    <div className="labelinput">
                        {/* <label>Company Name</label> */}
                        <input placeholder='Password' type="password" name="password" onChange={handleChange} />
                    </div>
                    {error && <div className='error'>{error}</div>}
                    <button className='button' onClick={handleSubmit}>Submit</button>
                </div>
            </div>
        </div>
    )
}

export default LoginForm